import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";

import Box from "components/Box";
import Stack from "components/Stack";
import Text from "components/Text";

import PrintableFieldWrapper from "pages/PrintableChecklist/components/PrintableFieldWrapper";

import { FieldType } from "entities/Field/sdk";
import { IPackageSection } from "entities/Package/sdk";

interface ISection {
  section: IPackageSection;
}

const PrintableSection = ({ section }: ISection) => {
  const areAllNA = useMemo(
    () => _.every(section.fields, { n_a_status: true }),
    [section]
  );

  return (
    <Box id={section.section_id.toString()}>
      <Box
        sx={{
          paddingY: 0.5,
          paddingX: 1,
          backgroundColor: colors.blue10,
          borderRadius: "4px",
          breakInside: "avoid",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            minHeight="32px"
          >
            <Text
              variant="text2"
              fontWeight="bold"
              color={areAllNA ? colors.gray60 : colors.black}
            >
              {section.name}
            </Text>
          </Stack>
        </Stack>
      </Box>
      <Box sx={{ paddingY: 1 }}>
        {_.uniqBy(section.fields, "field_id").map((field) => (
          <Stack
            sx={{
              pageBreakInside:
                field.field_type === FieldType.RICH_TEXT_FIELD
                  ? "initial"
                  : "avoid",
            }}
          >
            <PrintableFieldWrapper key={field.field_id} field={field} />
          </Stack>
        ))}
      </Box>
    </Box>
  );
};

export default PrintableSection;
